<script lang="ts">
  import DashboardLayout from '../../../layout/DashboardLayout.svelte';
  import { authState } from '../../auth/auth.state.svelte';
</script>

<DashboardLayout>
  <div class="p-8">
    <h2 class="text-2xl font-bold text-surface-100 mb-6">🛡️ Admin Panel</h2>

    <div class="bg-surface-800 rounded-xl p-6 border border-surface-700">
      <p class="text-surface-300 mb-4">
        This page is restricted to <span class="text-red-400 font-bold">admin</span> role only.
        Regular users are redirected away by the RouteGuard.
      </p>

      <!-- Mock user management table -->
      <table class="w-full text-sm text-left">
        <thead class="text-surface-500 border-b border-surface-700">
          <tr>
            <th class="py-3 px-4">Name</th>
            <th class="py-3 px-4">Email</th>
            <th class="py-3 px-4">Role</th>
          </tr>
        </thead>
        <tbody class="text-surface-300">
          <tr class="border-b border-surface-700/50">
            <td class="py-3 px-4">Admin User</td>
            <td class="py-3 px-4">admin@demo.com</td>
            <td class="py-3 px-4"><span class="px-2 py-1 bg-red-500/20 text-red-400 rounded text-xs">admin</span></td>
          </tr>
          <tr>
            <td class="py-3 px-4">Regular User</td>
            <td class="py-3 px-4">user@demo.com</td>
            <td class="py-3 px-4"><span class="px-2 py-1 bg-blue-500/20 text-blue-400 rounded text-xs">user</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</DashboardLayout>
